exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share[data-v-706fced2] {\n  position: relative;\n  line-height: 1;\n}\n.share span[data-v-706fced2] {\n  font-size: 1rem;\n}\n.share .whatsapp[data-v-706fced2]:before {\n  content: url(\"/svg/whatsapp-circle-dark.svg\");\n}\n.share .linkedin[data-v-706fced2]:before {\n  content: url(\"/svg/linkedin-circle-dark.svg\");\n}\n.share .facebook[data-v-706fced2]:before {\n  content: url(\"/svg/facebook-circle-dark.svg\");\n}\n.share .email[data-v-706fced2]:before {\n  content: url(\"/svg/email-circle-dark.svg\");\n}\n.share .messenger[data-v-706fced2]:before {\n  content: url(\"/svg/messenger-circle-dark.svg\");\n}", ""]);

// exports
